import { IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { getAzureAdConfig } from './azure-ad-env';

export function createMsalInstance(): IPublicClientApplication {
  const ad = getAzureAdConfig();
  if (!ad) {
    throw new Error('MSAL factory called while Azure AD is disabled in environment.');
  }
  return new PublicClientApplication({
    auth: {
      clientId: ad.clientId,
      authority: `https://login.microsoftonline.com/${ad.tenantId}`,
      redirectUri: ad.redirectUri,
      postLogoutRedirectUri: ad.redirectUri
    },
    cache: {
      cacheLocation: 'localStorage'
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning
      }
    }
  });
}
